import React from 'react';
import Typography from 'new/elements/Typography';
import { ReactComponent as AddIcon } from 'new/elements/flows/assets/add.svg';
import classes from './AddCredentialCard.module.scss';

interface AddCredentialCardProps {
  onClick: () => void;
}

export const AddCredentialCard = ({ onClick }: AddCredentialCardProps) => {
  return (
    <div className={classes.root} onClick={onClick} data-testid="add-credential-card">
      <div className={classes.content}>
        <AddIcon />
        <Typography variant="body1">Add Credential</Typography>
      </div>
    </div>
  );
};
